import { Helmet } from 'react-helmet';
import styles from './iacst-registration.module.scss';
import Faqaccordion from 'components/Registration/Faq/Faqaccrodion';
import { FAQConfig } from 'staticPages/constants';
import { useSelector } from 'react-redux';
import PageNotFound from 'components/404';

const IacstRegistration = () => {
  const examType = useSelector((state) => state.examType.examType)

  const faqQuestions = FAQConfig.iACST_Registration.map((item, index) => ({
    targetId: (index + 1).toString(),
    heading: item.question,
    subheading: item.answer,
    bulletpoints: []
  }))
  if (examType !== 'iACST') {
    return <PageNotFound />
  }
  return (
    <>
      <Helmet>
        <link rel="canonical" href="https://iacst.aakash.ac.in/iacst-registration" />
        <meta property="og:title" content="How to Apply for iACST Online? Step-by-Step Registration Process" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://iacst.aakash.ac.in/iacst-registration" />
        <meta property="og:title" content="iACST Registration – Win Up to 90% Scholarship | Aakash" />
        <meta property="og:description" content="Register for Aakash iACST – a free national-level online scholarship test for Class 6–12 and 12 pass students. Get instant scholarships on NEET, JEE & Foundation coaching. Take the test anytime from home!" />
        <meta property="og:image" content="https://iacst.aakash.ac.in/static/media/iACST_Hero_final.5d3da4d6.png" />
        <meta property="og:image:alt" content="instant Admission Cum Scholarship Test" />
        <meta property="og:site_name" content="Aakash iACST" />
        <meta property="og:locale" content="en_IN" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:url" content="https://iacst.aakash.ac.in/iacst-registration" />
        <meta name="twitter:title" content="iACST – Instant Admission Cum Scholarship Test | Aakash" />
        <meta name="twitter:description" content="Register for Aakash iACST (Instant Admission Cum Scholarship Test) – a free national-level online test for Class 6–12 and 12 pass students. Get instant scholarships up to 90% on NEET, JEE & Foundation coaching. Take the test anytime from home!" />
        <meta name="twitter:image" content="https://iacst.aakash.ac.in/static/media/iACST_Hero_final.5d3da4d6.png" />
        <meta name="twitter:image:alt" content="Aakash iACST – Instant Admission Cum Scholarship Test" />
        <meta name="twitter:site" content="@AESL_Official" />
      </Helmet>
      <div style={{ fontFamily: 'Arial, sans-serif' }}>
        <div style={{ width: '100%', backgroundColor: '#ffffff', padding: '10px 20px', boxSizing: 'border-box', borderBottom: '1px solid #e0e0e0' }}>
          <div style={{ maxWidth: 1400, margin: '0 auto', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <img src="https://uat-iacst.aakash.ac.in/static/media/aakash-logo.27a40e9d.png" alt="Aakash Logo" style={{ height: 55, width: 'auto' }} />
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
              <div style={{ backgroundColor: '#42a5f5', width: 40, height: 40, borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <img src="https://uat-iacst.aakash.ac.in/static/media/call-icon-iacst.cecbde51.svg" alt="calling-icon" style={{ width: 20, height: 20 }} />
              </div>
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <span style={{ fontSize: 14, color: '#444' }}>Call us</span>
                <a href="tel:7303529494" style={{ fontSize: 18, fontWeight: 'bold', color: '#2196f3', textDecoration: 'none', marginTop: 2 }}>7303529494</a>
              </div>
            </div>
          </div>
        </div>


        {/* Open Graph / Facebook */}








        {/* Twitter */}







        {/* SECTION 1 (Intro Split) */}
        <section style={{ width: '100%', padding: '30px 0', background: '#ffffff' }}>
          <div className={styles.iacstIntroWrap}>
            <div className={styles.iacstIntroRow}>
              <div className={styles.iacstIntroStrip}>
                <div className={styles.iacstIntroStripInner}>
                  <div className={styles.iacstIntroStripPattern} />
                  <div className={styles.iacstIntroStripText}>
                    <h3>Registration process<br />and preparation context</h3>
                  </div>
                </div>
              </div>
              <div className={styles.iacstIntroContent}>
                <h1 className={styles.iacstH1} style={{ fontSize: 36, fontWeight: 900, margin: '0 0 18px 0', lineHeight: '1.1', color: '#0f172a' }}>
                  iACST Registration
                </h1>
                <div className={styles.iacstIntroDivider} />
                <p className={styles.iacstIntroPara}>
                  Applications are an integral part of the process when taking a competitive examination. The iACST scholarship test conducted by Aakash happens to be a first encounter experience for most students. They understand the need for exercising caution when filling applications and the value of credible information sharing. Additionally, the preparation that follows helps build strong foundations in their respective STEM subjects. In this guide, we’ll help you understand how to go about the registration process for the iACST scholarship test.
                </p>
                <div className={styles.iacstIntroCallouts}>
                  <div className={styles.iacstCallout}>
                    <span className={styles.iacstCalloutIcon}>
                      <svg width={18} height={18} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ display: 'block' }}>
                        <path d="M12 2L20 6V12C20 16.4 16.7 20.2 12 22C7.3 20.2 4 16.4 4 12V6L12 2Z" stroke="#1d4ed8" strokeWidth={2} strokeLinejoin="round" />
                        <path d="M9 12L11 14L15 10" stroke="#1d4ed8" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    </span>
                    <span className={styles.iacstCalloutText}>Exercising Caution</span>
                  </div>
                  <div className={styles.iacstCallout}>
                    <span className={styles.iacstCalloutIcon}>
                      <svg width={18} height={18} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ display: 'block' }}>
                        <path d="M12 2L14.5 5.5L18.8 6.2L17 10L18.8 13.8L14.5 14.5L12 18L9.5 14.5L5.2 13.8L7 10L5.2 6.2L9.5 5.5L12 2Z" stroke="#1d4ed8" strokeWidth={2} strokeLinejoin="round" />
                        <path d="M9 12L11 14L15 10" stroke="#1d4ed8" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    </span>
                    <span className={styles.iacstCalloutText}>Credible Information Sharing</span>
                  </div>
                  <div className={styles.iacstCallout}>
                    <span className={styles.iacstCalloutIcon}>
                      <svg width={18} height={18} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ display: 'block' }}>
                        <path d="M8 4H12V7C12 7.6 12.4 8 13 8H16V12H19C19.6 12 20 12.4 20 13V16H16V19C16 19.6 15.6 20 15 20H12V16H8V12H4V9C4 8.4 4.4 8 5 8H8V4Z" stroke="#1d4ed8" strokeWidth={2} strokeLinejoin="round" />
                      </svg>
                    </span>
                    <span className={styles.iacstCalloutText}>Strong Foundations</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* ======================= STEP-BY-STEP REGISTRATION PROCESS ======================= */}
        <div id="step-registration" style={{ width: '100%', display: 'flex', justifyContent: 'center', padding: '30px 0', background: 'linear-gradient(135deg, #f2f7ff 0%, #ffffff 55%, #f7fbff 100%)' }}>
          <div className={styles.iacstStepWrap}>
            {/* Decorative bubbles */}
            <div className={styles.iacstBubble1} style={{ position: 'absolute', width: 260, height: 260, borderRadius: '50%', background: 'rgba(255, 255, 255, 0.16)', top: '-130px', right: '-130px' }} />
            <div className={styles.iacstBubble2} style={{ position: 'absolute', width: 220, height: 220, borderRadius: '50%', background: 'rgba(255, 255, 255, 0.12)', bottom: '-110px', left: '-110px' }} />
            {/* LEFT SVG (REPLACED IMAGE) */}
            <div className={styles.iacstStepLeft}>
              <div className={styles.iacstStepIllus}>
                {/* ✅ your existing SVG unchanged */}
                <svg viewBox="0 0 520 420" width="100%" height="auto" xmlns="http://www.w3.org/2000/svg" style={{ display: 'block', filter: 'drop-shadow(0 14px 30px rgba(15,23,42,0.18))' }} aria-label="Registration steps illustration" role="img">
                  {/* background glass card */}
                  <defs>
                    <linearGradient id="bgGrad" x1={0} y1={0} x2={1} y2={1}>
                      <stop offset={0} stopColor="rgba(255,255,255,0.78)" />
                      <stop offset="0.55" stopColor="rgba(245,250,255,0.62)" />
                      <stop offset={1} stopColor="rgba(255,255,255,0.70)" />
                    </linearGradient>
                    <linearGradient id="accentGrad" x1={0} y1={0} x2={1} y2={1}>
                      <stop offset={0} stopColor="#0ea5e9" />
                      <stop offset={1} stopColor="#1d4ed8" />
                    </linearGradient>
                    <filter id="softBlur" x="-30%" y="-30%" width="160%" height="160%">
                      <feGaussianBlur stdDeviation={12} />
                    </filter>
                    <filter id="cardShadow" x="-30%" y="-30%" width="160%" height="160%">
                      <feDropShadow dx={0} dy={16} stdDeviation={14} floodColor="rgba(15,23,42,0.18)" />
                    </filter>
                    <filter id="chipShadow" x="-30%" y="-30%" width="160%" height="160%">
                      <feDropShadow dx={0} dy={10} stdDeviation={10} floodColor="rgba(15,23,42,0.16)" />
                    </filter>
                  </defs>
                  {/* soft blobs */}
                  <circle cx={120} cy={90} r={70} fill="rgba(255,255,255,0.25)" filter="url(#softBlur)" />
                  <circle cx={410} cy={80} r={85} fill="rgba(255,255,255,0.20)" filter="url(#softBlur)" />
                  <circle cx={420} cy={320} r={95} fill="rgba(255,255,255,0.18)" filter="url(#softBlur)" />
                  {/* main card */}
                  <rect x={28} y={28} width={464} height={364} rx={22} fill="url(#bgGrad)" stroke="rgba(255,255,255,0.55)" filter="url(#cardShadow)" />
                  <rect x={34} y={34} width={452} height={352} rx={20} fill="rgba(255,255,255,0.25)" stroke="rgba(15,23,42,0.06)" />
                  {/* header */}
                  <rect x={58} y={62} width={260} height={44} rx={14} fill="rgba(255,255,255,0.65)" stroke="rgba(15,23,42,0.08)" />
                  <circle cx={82} cy={84} r={11} fill="url(#accentGrad)" />
                  <path d="M82 77.5 L86.2 84 L82 90.5 L77.8 84 Z" fill="white" opacity="0.95" />
                  <text x={104} y={90} fontFamily="Arial, sans-serif" fontSize={15} fontWeight={900} fill="#0b1b3a">
                    Register in 4 Steps
                  </text>
                  {/* big badge */}
                  <g>
                    <rect x={332} y={56} width={132} height={72} rx={18} fill="rgba(255,255,255,0.70)" stroke="rgba(15,23,42,0.10)" filter="url(#chipShadow)" />
                    <text x={398} y={92} textAnchor="middle" fontFamily="Arial, sans-serif" fontSize={26} fontWeight={900} fill="#0b1b3a">
                      Scholarship
                    </text>
                    <text x={398} y={114} textAnchor="middle" fontFamily="Arial, sans-serif" fontSize="12.5" fontWeight={800} fill="#1d4ed8">
                      Apply Online
                    </text>
                  </g>
                  {/* phone */}
                  <g transform="translate(80,132)">
                    <rect x={0} y={0} width={170} height={226} rx={22} fill="rgba(255,255,255,0.78)" stroke="rgba(15,23,42,0.10)" />
                    <rect x={16} y={20} width={138} height={160} rx={16} fill="rgba(14,165,233,0.10)" stroke="rgba(15,23,42,0.06)" />
                    <rect x={54} y={190} width={62} height={12} rx={6} fill="rgba(15,23,42,0.08)" />
                    <circle cx={85} cy={8} r={3} fill="rgba(15,23,42,0.18)" />
                    <rect x={30} y={38} width={110} height={14} rx={7} fill="rgba(255,255,255,0.80)" />
                    <rect x={30} y={62} width={88} height={12} rx={6} fill="rgba(255,255,255,0.75)" />
                    <rect x={30} y={86} width={120} height={12} rx={6} fill="rgba(255,255,255,0.75)" />
                    <rect x={30} y={110} width={98} height={12} rx={6} fill="rgba(255,255,255,0.75)" />
                    <rect x={30} y={136} width={110} height={28} rx={14} fill="url(#accentGrad)" />
                    <text x={85} y={155} textAnchor="middle" fontFamily="Arial, sans-serif" fontSize="12.5" fontWeight={900} fill="white">
                      Continue
                    </text>
                  </g>
                  {/* steps list */}
                  <g transform="translate(280,152)">
                    <g>
                      <rect x={0} y={0} width={200} height={44} rx={16} fill="rgba(255,255,255,0.70)" stroke="rgba(15,23,42,0.08)" />
                      <circle cx={22} cy={22} r={14} fill="url(#accentGrad)" />
                      <text x={22} y={27} textAnchor="middle" fontFamily="Arial, sans-serif" fontSize={14} fontWeight={900} fill="white">1</text>
                      <text x={48} y={27} fontFamily="Arial, sans-serif" fontSize="13.5" fontWeight={900} fill="#0b1b3a">Visit Portal</text>
                    </g>
                    <g transform="translate(0,56)">
                      <rect x={0} y={0} width={200} height={44} rx={16} fill="rgba(255,255,255,0.70)" stroke="rgba(15,23,42,0.08)" />
                      <circle cx={22} cy={22} r={14} fill="url(#accentGrad)" />
                      <text x={22} y={27} textAnchor="middle" fontFamily="Arial, sans-serif" fontSize={14} fontWeight={900} fill="white">2</text>
                      <text x={48} y={27} fontFamily="Arial, sans-serif" fontSize="13.5" fontWeight={900} fill="#0b1b3a">OTP Verify</text>
                    </g>
                    <g transform="translate(0,112)">
                      <rect x={0} y={0} width={200} height={44} rx={16} fill="rgba(255,255,255,0.70)" stroke="rgba(15,23,42,0.08)" />
                      <circle cx={22} cy={22} r={14} fill="url(#accentGrad)" />
                      <text x={22} y={27} textAnchor="middle" fontFamily="Arial, sans-serif" fontSize={14} fontWeight={900} fill="white">3</text>
                      <text x={48} y={27} fontFamily="Arial, sans-serif" fontSize="13.5" fontWeight={900} fill="#0b1b3a">Fill Details</text>
                    </g>
                    <g transform="translate(0,168)">
                      <rect x={0} y={0} width={200} height={44} rx={16} fill="rgba(255,255,255,0.70)" stroke="rgba(15,23,42,0.08)" />
                      <circle cx={22} cy={22} r={14} fill="url(#accentGrad)" />
                      <text x={22} y={27} textAnchor="middle" fontFamily="Arial, sans-serif" fontSize={14} fontWeight={900} fill="white">4</text>
                      <text x={48} y={27} fontFamily="Arial, sans-serif" fontSize="13.5" fontWeight={900} fill="#0b1b3a">Book Slot</text>
                    </g>
                  </g>
                  <text x={260} y={372} textAnchor="middle" fontFamily="Arial, sans-serif" fontSize="12.5" fontWeight={800} fill="rgba(11,27,58,0.72)">
                    Simple • Secure • Fast registration
                  </text>
                </svg>
              </div>
            </div>
            {/* RIGHT CONTENT */}
            <div className={styles.iacstStepRight}>
              {/* Heading */}
              <div className={styles.iacstStepHeading} style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                <span style={{ width: 48, height: 48, flex: '0 0 48px', minWidth: 48, minHeight: 48, maxWidth: 48, maxHeight: 48, borderRadius: 16, background: 'linear-gradient(135deg,#0ea5e9,#1d4ed8)', display: 'flex', alignItems: 'center', justifyContent: 'center', boxSizing: 'border-box' }} aria-hidden="true">
                  <svg width={22} height={22} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ display: 'block' }}>
                    <path d="M14 10L10 14" stroke="white" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M8.5 8.5C10.5 6.5 13.5 4.5 18.5 4.5C18.5 9.5 16.5 12.5 14.5 14.5C12.5 16.5 10 17.5 8 18L6 16C6.5 14 7.5 11.5 8.5 8.5Z" stroke="white" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M6.5 17.5L4.5 19.5" stroke="white" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M12 6.5C12.8 7.3 13.3 7.8 14.5 9" stroke="white" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </span>
                <h3 className={styles.iacstStepTitle} style={{ margin: 0, fontSize: 30, fontWeight: 900, color: '#0f172a', lineHeight: '1.2' }}>
                  Step-by-Step Registration Process for the iACST Scholarship Test
                </h3>
              </div>
              <p style={{ color: '#334155', margin: '14px 0 22px 0', fontSize: 16, lineHeight: '1.85' }}>
                Here’s the step-by-step registration process to apply for iACST online to ensure your application gets submitted successfully:
              </p>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
                <div className={styles.iacstStepRow} style={{ display: 'flex', gap: 14, padding: '14px 16px', borderRadius: 16, border: '1px solid #e7ecf6', background: 'linear-gradient(135deg,#fbfcff 0%, #ffffff 70%)' }}>
                  <span className={styles.iacstStepNum} style={{ width: 36, height: 36, flex: '0 0 36px', minWidth: 36, minHeight: 36, maxWidth: 36, maxHeight: 36, borderRadius: '50%', background: '#002f6c', color: '#fff', display: 'flex', justifyContent: 'center', alignItems: 'center', fontWeight: 800 }}>
                    1
                  </span>
                  <div>
                    <h4 style={{ display: 'flex', margin: 0, fontSize: 17, fontWeight: 900, color: '#0f172a', justifySelf: 'flex-start' }}>Step 1: Visit Portal</h4>
                    <p style={{ margin: '6px 0 0 0', color: '#334155', lineHeight: '1.6' }}>
                      Visit the official Aakash iACST scholarship test portal to begin registration.
                    </p>
                  </div>
                </div>
                <div className={styles.iacstStepRow} style={{ display: 'flex', gap: 14, padding: '14px 16px', borderRadius: 16, border: '1px solid #e7ecf6', background: 'linear-gradient(135deg,#fbfcff 0%, #ffffff 70%)' }}>
                  <span className={styles.iacstStepNum} style={{ width: 36, height: 36, flex: '0 0 36px', minWidth: 36, minHeight: 36, maxWidth: 36, maxHeight: 36, borderRadius: '50%', background: '#002f6c', color: '#fff', display: 'flex', justifyContent: 'center', alignItems: 'center', fontWeight: 800 }}>
                    2
                  </span>
                  <div>
                    <h4 style={{ display: 'flex', margin: 0, fontSize: 17, fontWeight: 900, color: '#0f172a', justifySelf: 'flex-start' }}>Step 2: Verification</h4>
                    <p style={{ margin: '6px 0 0 0', color: '#334155', lineHeight: '1.6' }}>
                      Enter your mobile number and verify it using the OTP sent to you.
                    </p>
                  </div>
                </div>
                <div className={styles.iacstStepRow} style={{ display: 'flex', gap: 14, padding: '14px 16px', borderRadius: 16, border: '1px solid #e7ecf6', background: 'linear-gradient(135deg,#fbfcff 0%, #ffffff 70%)' }}>
                  <span className={styles.iacstStepNum} style={{ width: 36, height: 36, flex: '0 0 36px', minWidth: 36, minHeight: 36, maxWidth: 36, maxHeight: 36, borderRadius: '50%', background: '#002f6c', color: '#fff', display: 'flex', justifyContent: 'center', alignItems: 'center', fontWeight: 800 }}>
                    3
                  </span>
                  <div>
                    <h4 style={{ display: 'flex', margin: 0, fontSize: 17, fontWeight: 900, color: '#0f172a', justifySelf: 'flex-start' }}>Step 3: Fill in Details</h4>
                    <p style={{ margin: '6px 0 0 0', color: '#334155', lineHeight: '1.6' }}>
                      Provide your academic details such as class, subjects, and required information.
                    </p>
                  </div>
                </div>
                <div className={styles.iacstStepRow} style={{ display: 'flex', gap: 14, padding: '14px 16px', borderRadius: 16, border: '1px solid #e7ecf6', background: 'linear-gradient(135deg,#fbfcff 0%, #ffffff 70%)' }}>
                  <span className={styles.iacstStepNum} style={{ width: 36, height: 36, flex: '0 0 36px', minWidth: 36, minHeight: 36, maxWidth: 36, maxHeight: 36, borderRadius: '50%', background: '#002f6c', color: '#fff', display: 'flex', justifyContent: 'center', alignItems: 'center', fontWeight: 800 }}>
                    4
                  </span>
                  <div>
                    <h4 style={{ display: 'flex', margin: 0, fontSize: 17, fontWeight: 900, color: '#0f172a', justifySelf: 'flex-start' }}>Step 4: Set up a Slot</h4>
                    <p style={{ margin: '6px 0 0 0', color: '#334155', lineHeight: '1.6' }}>
                      Choose your preferred test date and time slot after planning your preparation.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <section style={{ background: '#ffffff', width: '100%', padding: '30px 0' }}>
          <div style={{ width: '90%', margin: 'auto', maxWidth: 1100 }}>
            <div className={styles.iacstCard} style={{ padding: 40, position: 'relative', overflow: 'hidden' }}>
              <div style={{ position: 'absolute', width: 560, height: 260, borderRadius: 999, background: 'linear-gradient(90deg, rgba(59,130,246,0.12), rgba(99,102,241,0.08), rgba(14,165,233,0.00))', top: '-90px', right: '-220px' }} />
              <div className={styles.iacstChip}>
                <svg width={16} height={16} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ display: 'block' }}>
                  <path d="M12 2L13.5 8.5L20 10L13.5 11.5L12 18L10.5 11.5L4 10L10.5 8.5L12 2Z" stroke="#1d4ed8" strokeWidth={2} strokeLinejoin="round" />
                </svg>
                Opportunity
              </div>
              <h2
                style={{
                  fontSize: 34,
                  fontWeight: 900,
                  margin: '16px 0 12px 0',
                  color: '#0f172a',
                  fontFamily: 'Roboto, sans-serif',
                  lineHeight: 1.5
                }}
              >
                What is the iACST Scholarship Test?
              </h2>
              <p style={{ margin: '0 0 18px 0', color: '#334155', lineHeight: '1.9', fontSize: 17 }}>
                Designed to sieve out the rare gems and young overachievers with brilliant minds, the iACST scholarship test is a golden opportunity. All students in Class 6 and above are able to sit for the exam and assess their learning status through the exam. It evaluates foundational understanding and thinking abilities in students.
              </p>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: 14, marginTop: 14 }}>
                <div className={styles.iacstCard} style={{ padding: 18, background: 'linear-gradient(135deg,#fbfcff 0%, #ffffff 60%)' }}>
                  <div style={{ display: 'flex', gap: 10, alignItems: 'flex-start' }}>
                    <div style={{ width: 40, height: 40, borderRadius: 12, background: '#eef5ff', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <svg width={20} height={20} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ display: 'block' }}>
                        <path d="M12 2L22 9L12 22L2 9L12 2Z" stroke="#1d4ed8" strokeWidth={2} strokeLinejoin="round" />
                        <path d="M2 9H22" stroke="#1d4ed8" strokeWidth={2} />
                      </svg>
                    </div>
                    <p style={{ margin: 0, color: '#0f172a', lineHeight: '1.7' }}>
                      Designed to sieve out the rare gems and young overachievers with brilliant minds, the iACST scholarship test is a golden opportunity.
                    </p>
                  </div>
                </div>
                <div className={styles.iacstCard} style={{ padding: 18, background: 'linear-gradient(135deg,#ffffff 0%, #f7fbff 80%)' }}>
                  <div style={{ display: 'flex', gap: 10, alignItems: 'flex-start' }}>
                    <div style={{ width: 40, height: 40, borderRadius: 12, background: '#eaf7ff', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <svg width={20} height={20} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ display: 'block' }}>
                        <path d="M12 3L2 9L12 15L22 9L12 3Z" stroke="#1d4ed8" strokeWidth={2} strokeLinejoin="round" />
                        <path d="M6 12V17C6 19 9 21 12 21C15 21 18 19 18 17V12" stroke="#1d4ed8" strokeWidth={2} strokeLinejoin="round" />
                      </svg>
                    </div>
                    <p style={{ margin: 0, color: '#0f172a', lineHeight: '1.7' }}>
                      All students in Class 6 and above are able to sit for the exam and assess their learning status through the exam.
                    </p>
                  </div>
                </div>
                <div className={styles.iacstCard} style={{ padding: 18, background: 'linear-gradient(135deg,#fbfcff 0%, #ffffff 60%)' }}>
                  <div style={{ display: 'flex', gap: 10, alignItems: 'flex-start' }}>
                    <div style={{ width: 40, height: 40, borderRadius: 12, background: '#eefdf3', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <svg width={20} height={20} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ display: 'block' }}>
                        <path d="M9 4C7 4 5.5 5.5 5.5 7.5V9C4.5 9 4 10 4 11V13C4 14 4.5 15 5.5 15V17.5C5.5 19.5 7 21 9 21" stroke="#1d4ed8" strokeWidth={2} strokeLinecap="round" />
                        <path d="M15 4C17 4 18.5 5.5 18.5 7.5V9C19.5 9 20 10 20 11V13C20 14 19.5 15 18.5 15V17.5C18.5 19.5 17 21 15 21" stroke="#1d4ed8" strokeWidth={2} strokeLinecap="round" />
                        <path d="M9 8H15" stroke="#1d4ed8" strokeWidth={2} />
                        <path d="M9 14H15" stroke="#1d4ed8" strokeWidth={2} />
                      </svg>
                    </div>
                    <p style={{ margin: 0, color: '#0f172a', lineHeight: '1.7' }}>
                      It evaluates foundational understanding and thinking abilities in students.
                    </p>
                  </div>
                </div>
              </div>
              <div style={{ marginTop: 18, padding: '16px 18px', borderRadius: 14, border: '1px dashed #cfe0ff', background: '#f7fbff' }}>
                <p style={{ margin: 0, color: '#334155', lineHeight: '1.9' }}>
                  Those who perform well in the test are able to earn scholarships that go up to 90%. These scholarships help students get high-quality coaching and mentorship in their Aakash classroom/foundational course of choice. The fee waiver achieved through the scholarship lifts the economic burden of expensive coaching classes for parents.
                </p>
              </div>
            </div>
          </div>
        </section>
        <section style={{ background: '#f9fafc', width: '100%', padding: '30px 0' }}>
          <div className={styles.iacstPanelWrap}>
            <div className={styles.iacstFlex}>
              <div className={`${styles.iacstCard} ${styles.iacstDetails}`} style={{ flex: 1, minWidth: 320, padding: 34, background: '#ffffff' }}>
                <div className={styles.iacstChip}>
                  <svg width={16} height={16} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ display: 'block' }}>
                    <path d="M9 2H15V4H19V22H5V4H9V2Z" stroke="#1d4ed8" strokeWidth={2} strokeLinejoin="round" />
                    <path d="M9 4H15" stroke="#1d4ed8" strokeWidth={2} />
                  </svg>
                  Test details
                </div>
                <h2 style={{ fontSize: 34, fontWeight: 900, margin: '16px 0 14px 0', color: '#0f172a' }}>
                  Test Details of the iACST Scholarship Test
                </h2>
                <p style={{ margin: '0 0 18px 0', color: '#334155', lineHeight: '1.9', fontSize: 17 }}>
                  The test details of the iACST scholarship test will aid you when preparing to take the exam:
                </p>
                <div className={styles.iacstTable}>
                  <div style={{ padding: '16px 18px', borderBottom: '1px solid #e7ecf6', fontWeight: 900, color: '#0f172a', background: '#ffffff' }}>
                    Overview
                  </div>
                  <div style={{ padding: '6px 18px 0 18px' }}>
                    <div className={styles.iacstRow}>
                      <div className={styles.iacstK}>
                        <span style={{ width: 34, height: 34, borderRadius: 12, background: '#eef5ff', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                          <svg width={18} height={18} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ display: 'block' }}>
                            <path d="M12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22Z" stroke="#1d4ed8" strokeWidth={2} />
                            <path d="M12 6V12L16 14" stroke="#1d4ed8" strokeWidth={2} strokeLinecap="round" />
                          </svg>
                        </span>
                        Duration of Exam
                      </div>
                      <div className={styles.iacstV}>1 hour</div>
                    </div>
                    <div className={styles.iacstRow}>
                      <div className={styles.iacstK}>
                        <span style={{ width: 34, height: 34, borderRadius: 12, background: '#eaf7ff', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                          <svg width={18} height={18} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ display: 'block' }}>
                            <path d="M4 5H20V15H4V5Z" stroke="#1d4ed8" strokeWidth={2} strokeLinejoin="round" />
                            <path d="M2 19H22" stroke="#1d4ed8" strokeWidth={2} strokeLinecap="round" />
                          </svg>
                        </span>
                        Mode of Examination
                      </div>
                      <div className={styles.iacstV}>Online</div>
                    </div>
                    <div className={styles.iacstRow}>
                      <div className={styles.iacstK}>
                        <span style={{ width: 34, height: 34, borderRadius: 12, background: '#eefdf3', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                          <svg width={18} height={18} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ display: 'block' }}>
                            <path d="M12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22Z" stroke="#1d4ed8" strokeWidth={2} />
                            <path d="M2 12H22" stroke="#1d4ed8" strokeWidth={2} />
                            <path d="M12 2C14.5 5 14.5 19 12 22C9.5 19 9.5 5 12 2Z" stroke="#1d4ed8" strokeWidth={2} />
                          </svg>
                        </span>
                        Language of Examination
                      </div>
                      <div className={styles.iacstV}>English</div>
                    </div>
                    <div className={styles.iacstRow}>
                      <div className={styles.iacstK}>
                        <span style={{ width: 34, height: 34, borderRadius: 12, background: '#fff4e6', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                          <svg width={18} height={18} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ display: 'block' }}>
                            <path d="M4 5H20V21H4V5Z" stroke="#1d4ed8" strokeWidth={2} strokeLinejoin="round" />
                            <path d="M4 9H20" stroke="#1d4ed8" strokeWidth={2} />
                            <path d="M8 3V7M16 3V7" stroke="#1d4ed8" strokeWidth={2} strokeLinecap="round" />
                          </svg>
                        </span>
                        Duration of Test Availability
                      </div>
                      <div className={styles.iacstV}>30 days</div>
                    </div>
                    <div className={styles.iacstRow}>
                      <div className={styles.iacstK}>
                        <span style={{ width: 34, height: 34, borderRadius: 12, background: '#eef5ff', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                          <svg width={18} height={18} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ display: 'block' }}>
                            <path d="M7 3V7M17 3V7" stroke="#1d4ed8" strokeWidth={2} strokeLinecap="round" />
                            <path d="M4 7H20V21H4V7Z" stroke="#1d4ed8" strokeWidth={2} />
                            <path d="M8 11H16M8 15H16" stroke="#1d4ed8" strokeWidth={2} strokeLinecap="round" />
                          </svg>
                        </span>
                        Days of Test Availability
                      </div>
                      <div className={styles.iacstV}>Monday to Sunday (All days of the week)</div>
                    </div>
                    <div className={styles.iacstRow} style={{ borderBottom: 'none' }}>
                      <div className={styles.iacstK}>
                        <span style={{ width: 34, height: 34, borderRadius: 12, background: '#eaf7ff', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                          <svg width={18} height={18} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ display: 'block' }}>
                            <path d="M12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22Z" stroke="#1d4ed8" strokeWidth={2} />
                            <path d="M12 7V12H17" stroke="#1d4ed8" strokeWidth={2} strokeLinecap="round" />
                          </svg>
                        </span>
                        Time of Test Availability
                      </div>
                      <div className={styles.iacstV}>9 AM to 10 PM</div>
                    </div>
                  </div>
                </div>
              </div>
              <div className={styles.iacstImpact} style={{ flex: '0 0 340px', minWidth: 280, borderRadius: 18, padding: 26, color: '#ffffff', background: 'linear-gradient(145deg,#0ea5e9 0%, #1d4ed8 55%, #4f46e5 100%)', boxShadow: '0 14px 36px rgba(14,165,233,0.18)', position: 'relative', overflow: 'hidden' }}>
                <div style={{ position: 'absolute', width: 260, height: 260, borderRadius: '50%', background: 'rgba(255,255,255,0.14)', top: '-140px', left: '-140px' }} />
                <div style={{ position: 'absolute', width: 220, height: 220, borderRadius: '50%', background: 'rgba(255,255,255,0.10)', bottom: '-120px', right: '-120px' }} />
                <div style={{ position: 'relative' }}>
                  <div style={{ display: 'inline-flex', alignItems: 'center', gap: 10, padding: '10px 14px', borderRadius: 999, background: 'rgba(255,255,255,0.16)', border: '1px solid rgba(255,255,255,0.22)', fontWeight: 900, fontSize: 14 }}>
                    <svg width={16} height={16} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ display: 'block' }}>
                      <path d="M4 19V5" stroke="white" strokeWidth={2} strokeLinecap="round" />
                      <path d="M4 19H20" stroke="white" strokeWidth={2} strokeLinecap="round" />
                      <path d="M7 15L11 11L14 14L20 8" stroke="white" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
                      <path d="M20 8V12" stroke="white" strokeWidth={2} strokeLinecap="round" />
                    </svg>
                    Impact
                  </div>
                  <h3 style={{ margin: '14px 0 10px 0', fontSize: 22, fontWeight: 900 }}>Over 1,55,000 students</h3>
                  <p style={{ margin: 0, lineHeight: '1.9', opacity: '0.95' }}>
                    Over 1,55,000 students have been able to begin their JEE/NEET preparation journey early through scholarships awarded to them for their iACST performance. Engineering aspirants have opted for their Aakash JEE classroom courses of preference. Similarly, many medical aspirants have opted for Aakash NEET classroom courses to grow holistically.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section style={{ background: '#ffffff', width: '100%', padding: '28px 0' }}>
          <div className={styles.iacstMoreDetails}>
            <div className={styles.iacstWrap}>
              <div className={styles.iacstBox} style={{ marginBottom: '36px' }}>
                <h2 className={styles.iacstTitle}>Get More Details About IACST :</h2>
                <div className={styles.iacstTabs}>
                  <a className={styles.iacstTab} href="https://iacst.aakash.ac.in/" target="_blank" rel="noopener noreferrer">
                    <span className={styles.iacstIcon} aria-hidden="true">
                      <svg width={18} height={18} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 3L14.7 8.3L20.5 9.2L16.3 13.3L17.3 19L12 16.2L6.7 19L7.7 13.3L3.5 9.2L9.3 8.3L12 3Z" stroke="#1d4ed8" strokeWidth={2} strokeLinejoin="round" />
                      </svg>
                    </span>
                    <span>IACST Scholarship</span>
                  </a>
                  <a className={styles.iacstTab} href="/iacst-registration" target="_blank" rel="noopener noreferrer">
                    <span className={styles.iacstIcon} aria-hidden="true">
                      <svg width={18} height={18} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M9 4H15" stroke="#1d4ed8" strokeWidth={2} strokeLinecap="round" />
                        <path d="M9 3H15C16.1 3 17 3.9 17 5V6H7V5C7 3.9 7.9 3 9 3Z" stroke="#1d4ed8" strokeWidth={2} strokeLinejoin="round" />
                        <path d="M7 6H17C18.1 6 19 6.9 19 8V19C19 20.1 18.1 21 17 21H7C5.9 21 5 20.1 5 19V8C5 6.9 5.9 6 7 6Z" stroke="#1d4ed8" strokeWidth={2} strokeLinejoin="round" />
                        <path d="M9 11H15" stroke="#1d4ed8" strokeWidth={2} strokeLinecap="round" />
                        <path d="M9 15H13" stroke="#1d4ed8" strokeWidth={2} strokeLinecap="round" />
                      </svg>
                    </span>
                    <span>IACST Registration</span>
                  </a>
                  <a className={styles.iacstTab} href="/iacst-result" target="_blank" rel="noopener noreferrer">
                    <span className={styles.iacstIcon} aria-hidden="true">
                      <svg width={18} height={18} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4 20H20" stroke="#1d4ed8" strokeWidth={2} strokeLinecap="round" />
                        <path d="M7 16V10" stroke="#1d4ed8" strokeWidth={2} strokeLinecap="round" />
                        <path d="M12 16V6" stroke="#1d4ed8" strokeWidth={2} strokeLinecap="round" />
                        <path d="M17 16V12" stroke="#1d4ed8" strokeWidth={2} strokeLinecap="round" />
                      </svg>
                    </span>
                    <span>IACST Result</span>
                  </a>
                  <a className={styles.iacstTab} href="/iacst-eligibility" target="_blank" rel="noopener noreferrer">
                    <span className={styles.iacstIcon} aria-hidden="true">
                      <svg width={18} height={18} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 3L19 6V11C19 15.4 16.2 19.4 12 21C7.8 19.4 5 15.4 5 11V6L12 3Z" stroke="#1d4ed8" strokeWidth={2} strokeLinejoin="round" />
                        <path d="M9 12L11 14L15 10" stroke="#1d4ed8" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    </span>
                    <span>IACST Eligibility Criteria</span>
                  </a>
                  <a className={styles.iacstTab} href="https://iacst.aakash.ac.in/iacstexam" target="_blank" rel="noopener noreferrer">
                    <span className={styles.iacstIcon} aria-hidden="true">
                      <svg width={18} height={18} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4 6H20V15H4V6Z" stroke="#1d4ed8" strokeWidth={2} strokeLinejoin="round" />
                        <path d="M2 18H22" stroke="#1d4ed8" strokeWidth={2} strokeLinecap="round" />
                        <path d="M10 10H14" stroke="#1d4ed8" strokeWidth={2} strokeLinecap="round" />
                      </svg>
                    </span>
                    <span>Online IACST Scholarship</span>
                  </a>
                </div>
              </div>
              <Faqaccordion
                questions={faqQuestions} />
            </div>
          </div>
        </section>
        <footer className={"signupStyles_foot_sec__9tgVD"} style={{ backgroundColor: '#0f0f0f', padding: 28, textAlign: 'center' }}>
          <p className={"mb-0"} style={{ fontSize: 14, color: 'white' }}>
            © 2026 All right reserved by Aakash Educational Services Limited | Email Us:
            <a href="mailto:acstsupport@aesl.in" style={{ textDecoration: 'none', color: 'white' }}>acstsupport@aesl.in</a>
          </p>
        </footer>
      </div>
    </>
  );
};

export default IacstRegistration;
